<template>
  <div class="checkout-builder-backgroud-color px-5">
    <bp-checkbox
      v-model="color"
      id="#fff"
      name="Claro"
      @input="saveBackground"
    />

    <bp-checkbox
      v-model="color"
      id="#191919"
      name="Escuro"
      @input="saveBackground"
    />

    <form-group
      v-model="color"
      color
      label="Cor do fundo"
      id="background-color"
      placeholder="Ex.: #000000"
      @input="saveBackground"
    />
  </div>
</template>

<script>
let timeout;
export default {
  computed: {
    color: {
      get() {
        return this.$store.state.checkoutBuilder?.background?.color;
      },
      set(v) {
        this.$store.commit("checkoutBuilder/setBackground", {
          image: "",
          color: v ?? ""
        });
      }
    }
  },
  methods: {
    saveBackground() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.$store.dispatch("checkoutBuilder/saveSnapshot");
      }, 500);
    }
  }
};
</script>
